import dayjs, { Dayjs } from 'dayjs';


export const dateToKey = (date: string | Dayjs | undefined) => {
  const dateJs = dayjs(date);
  const dateArray = [
    dateJs.year(),
    dateJs.month(),
    dateJs.date(),
    dateJs.hour(),
    dateJs.minute(),
    dateJs.second()
  ];
  return (Number(dateArray.join('')));
};

